import { L10nContext } from 'context/L10nContext';
import { Guid } from 'lib/guid/Guid';

import { CardEmpty } from 'presentation/ui/components/cards/card-empty/CardEmpty';
import {
	ModalDialogueSectionColumnListWrapper
} from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section-column-list-wrapper/ModalDialogueSectionColumnListWrapper';
import { CardCollectionLayout } from 'presentation/ui/layouts/card-collection-layout/CardCollectionLayout';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonSecondary } from 'presentation/ui/partials/button/button-secondary/ButtonSecondary';
import { CardItemControlActionType } from 'presentation/ui/partials/card/card-item-controls/CardItemControlType';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { useContext } from 'react';
import { AuthContext } from 'services/core/context/AuthContext';
import { Permission } from 'services/core/lib/auth/AuthService';
import { DocumentViewModel } from 'services/documents/domain/model/DocumentModel';
import { DocumentEntry } from 'services/documents/presentation/ui/document-entry/DocumentEntry';

export interface RecordDocumentCollectionProps {
	recordDocuments: Readonly<Array<DocumentViewModel>>;
	onAddDocument?: () => void;
	isReportView?: boolean;
	onAction: (payload: CardItemControlActionType, document: DocumentViewModel) => void;
}

export const RecordDocumentCollection = (props: RecordDocumentCollectionProps): JSX.Element => {
	const { recordDocuments, isReportView, onAddDocument, onAction } = props;

	const authContext = useContext(AuthContext);
	const l10nContext = useContext(L10nContext);

	const renderDocumentCards = () => {
		let cards;

		if (recordDocuments.length > 0) {
			cards = recordDocuments.map((document: DocumentViewModel) => (
				<DocumentEntry
					isReportView={isReportView}
					key={Guid.generate()}
					documentEntry={document}
					onActionClick={onAction}
				/>
			));
		} else {
			cards = <CardEmpty message={l10nContext.translate('common.cards.emptyDefault.documents', 'kein Dokument')} />;
		}

		return cards;
	};

	return (
		<ModalDialogueSectionColumnListWrapper>
			<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					{!isReportView ? <ButtonSecondary
						buttonText={l10nContext.translate('view.documents.collection.documents.addButton', 'Dokument hinzufügen')}
						icon={IconIdentifier.ADD}
						onClick={onAddDocument}
						disabled={!authContext.hasPermission(Permission.RECORD_UPDATE_ADD_DOCUMENT)}
					/> : null}
				</ColumnLayoutSection>
			</ColumnLayout>

			<ColumnLayout mode={ColumnLayoutMode.ALIGN_CENTER}>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					<CardCollectionLayout>
						{renderDocumentCards()}
					</CardCollectionLayout>
				</ColumnLayoutSection>
			</ColumnLayout>
		</ModalDialogueSectionColumnListWrapper>
	);
};
